import Action from './Action'
import store from '../../store'

export default class ShowJobProgressAction extends Action {
  handle () {
    store.dispatch('ui/setShowJobProgress', this.data)
  }
}
